/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ReactHtmlParser from 'react-html-parser';
import { useUIDSeed } from 'react-uid';
import {
    object,
} from 'prop-types';
import Data from './ViewData';

const styles = (theme)  => ({
    sympathyContainer: {
        padding: '16px',
        letterSpacing: '0.03em',
        maxWidth: '1000px',
        margin: '0 auto',
    },
    headerTitle: {
        fontSize: '24px',
        textAlign: 'center',
        margin: '15px 0',
        fontWeight: 'bold',
    },
    authorHeader: {
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStyle: 'italic',
        margin: '10px  0',
    },
    wishesDescription: {
        fontSize: '14px',
        padding: '10px',
        '& a': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    wishesListTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
    },
    sympathyImage: {
        textAlign: 'center',
    },
});

const SympathySandraWellWishes = ({ classes }) => {
    const seed = useUIDSeed();
    const {
        HeaderTitle, AuthorName, InspirationTitle, InspirationDescription,
        AdditionalWaysWishes,
    } = Data;
    return (
        <>
            <Grid container className={classes.sympathyContainer}>
                <Grid item xs={12}>
                    <Typography className={classes.headerTitle}>{HeaderTitle}</Typography>
                    <Typography className={classes.authorHeader}>{AuthorName}</Typography>
                    <Typography className={classes.authorHeader}>{InspirationTitle}</Typography>
                    <Typography className={classes.wishesDescription}>{InspirationDescription}</Typography>
                </Grid>
                <Grid item xs={12}>
                    {AdditionalWaysWishes.map((item) => (
                        <div key={seed(item)}>
                            <div className={classes.sympathyImage}>
                                <img
                                    src={`${item.Image}`}
                                    alt={item.AltText}
                                />
                            </div>
                            <Typography className={classes.wishesDescription}>{item.WishesDescription}</Typography>
                            <Typography className={classes.wishesDescription}>{item.WishesAlternateDescription}</Typography>
                            <Typography className={classes.wishesListTitle}>{item.WishesListTitle}</Typography>
                            {item.WishesList ? (
                                <ul className={classes.wishesDescription}>
                                    {item.WishesList ? item.WishesList.map((wishesList) => (
                                        <li key={seed(wishesList)}>{ReactHtmlParser(wishesList.Content)}</li>
                                    )) : null}
                                </ul>
                            ) : null}
                        </div>
                    ))}
                </Grid>
            </Grid>
        </>
    );
};
SympathySandraWellWishes.propTypes = {
    classes: object.isRequired,
};
export default withStyles(styles)(SympathySandraWellWishes);
